<template>
  <div style="text-align: left; width: 100%">
    <div v-if="c">
      <span class="record-label">Daxil olunub:</span>
      <span class="record-label">{{ c }}</span>
    </div>
    <div v-if="u">
      <span class="record-label">Düzəliş olunub:</span>
      <span class="record-label">{{ u }}</span>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    created: String,
    updated: String,
  },
  data() {
    return {
      c: this.created,
      u: this.updated,
    };
  },
  watch: {
    created() {
      this.c = this.created;
    },
    updated() {
      this.u = this.updated;
    },
  },
};
</script>

<style>
.record-label {
  font-size: 12px;
  white-space: nowrap;
}
</style>
